// crewbit-admin/src/components/money/settings/SettingsGearLink.tsx
//
// Gear icon button — single component injected into PageHeader.secondaryActions
// slot on Money pages (Overview, Outstanding, Expenses, Tax). Click navigates
// to /money/settings landing.
//
// Per Decision §Settings.D6 — sits LEFT of HeaderQuickActionsButton ('+'),
// per PageHeader render order (secondaryActions before primaryAction).

import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { palette, radii, transition } from '../../../styles/tokens';

interface SettingsGearLinkProps {
  label?: string;
}

export default function SettingsGearLink({ label = 'Money settings' }: SettingsGearLinkProps) {
  return (
    <Link
      to="/money/settings"
      title={label}
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: radii.md,
        border: `1px solid ${palette.g150}`,
        background: palette.white,
        color: palette.g600,
        textDecoration: 'none',
        transition: `background ${transition.fast}, color ${transition.fast}`,
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = palette.g50;
        e.currentTarget.style.color = palette.g800;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = palette.white;
        e.currentTarget.style.color = palette.g600;
      }}
    >
      <Settings size={18} strokeWidth={1.8} />
    </Link>
  );
}
